import React from 'react';
import PropTypes from 'prop-types';
import { RadioButton } from 'components/UI/RadioButton/RadioButton';
import { AccordionCollapsible } from '../DeliveryMethodsAccordion/AccordionCollapsible';

export const DeliveryMethodVenueCollection = (props) => {
  const {
    DeliveryMethodId,
    DeliveryMethodDisplayName,
    DeliveryMethodFeeDescription,
    DeliveryMethodDescription,
    selectedDeliveryMethodId,
    handleRadioButtonChange,
  } = props;
  const isChecked = selectedDeliveryMethodId === DeliveryMethodId;

  return (
    <>
      <RadioButton
        id={`delivery-option-${DeliveryMethodId}`}
        label={DeliveryMethodDisplayName}
        name="deliveryOptions"
        onChangeHandler={() => handleRadioButtonChange(DeliveryMethodId)}
        smallLabelText={DeliveryMethodFeeDescription}
        value={DeliveryMethodId}
        isChecked={isChecked}
        key={DeliveryMethodId}
        extendClass="panel"
      >
        <AccordionCollapsible id={`collapse-${DeliveryMethodId}`} isActive={isChecked}>
          <div className="delivery-info collapse-content">
            <small>{DeliveryMethodDescription}</small>
          </div>
        </AccordionCollapsible>
      </RadioButton>
      <hr />
    </>
  );
};

DeliveryMethodVenueCollection.propTypes = {
  DeliveryMethodId: PropTypes.number,
  DeliveryMethodDisplayName: PropTypes.string,
  DeliveryMethodFeeDescription: PropTypes.string,
  DeliveryMethodDescription: PropTypes.string,
  selectedDeliveryMethodId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  handleRadioButtonChange: PropTypes.func,
};
